import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { AspNetworkIssueComponent } from './asp-network-issue.component';

const routes: Routes = [
  {
      path: 'network-issue',
      component: AspNetworkIssueComponent,      
  },
];
@NgModule({
  declarations: [AspNetworkIssueComponent],
  imports: [
    RouterModule.forChild(routes),
        CommonModule,
        MatIconModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
            MatProgressBarModule,
            MatInputModule,
            MatFormFieldModule,
            BrowserAnimationsModule,
            ReactiveFormsModule
  ],
      exports: [AspNetworkIssueComponent,RouterModule],
  
})
export class AspNetworkIssueModule { }
